
import EDGrid from '../GridComponents/EDGrid';
import { GridLegacyProps } from '@mui/material/GridLegacy';

/**
 * Ett enkelt sätt att skapa flera kolumner om bredden på fönstret tillåter det. Notera att antalet element i varje kolumn styrs hårt, så detta är inte flödande kolumner.
 */
interface IProps {
  spacing?: number;
  maxWidth?: string | number;
}
const EDColumns: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => (
  <EDGrid container spacing={props.spacing ?? 2} maxWidth={props.maxWidth}>
    {props.children}
  </EDGrid>
);

interface IColumnProps extends GridLegacyProps {
  spacing?: number;
  maxWidth?: string | number;
}

/**
 * Ett enkelt sätt att skapa flera kolumner om bredden på fönstret tillåter det. Notera att antalet element i varje kolumn styrs hårt, så detta är inte flödande kolumner.
 */
export const EDColumn: React.FunctionComponent<
  React.PropsWithChildren<IColumnProps>
> = props => {
  const { md, xs, ...rest } = props;
  return (
    <EDGrid item xs={xs ?? 12} md={md ?? 6} {...rest}>
      {props.children}
    </EDGrid>
  );
};
export default EDColumns;
